export default function (cli) {
  return {
    getSettings () {
      return cli.get(`${cli.crmApiEndpoint}settings/`).query()
    },
    editSettings (data) {
      return cli.patch(`${cli.crmApiEndpoint}settings/${data.pk}/`).send(data)
    },
    shopCalculateBill () {
      return cli.put(`${cli.crmApiEndpoint}settings/bill-calculate/`).send()
    },
    shopCalculatePromotion () {
      return cli.put(`${cli.crmApiEndpoint}settings/promotion-calculate/`).send()
    },
    shopSetCustomerAge () {
      return cli.put(`${cli.crmApiEndpoint}settings/set-age/`).send()
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/crm/settings.js